import { render, staticRenderFns } from "./DeclaracionJuradaBeneficioZonaFranca.vue?vue&type=template&id=abf31f8e&"
import script from "./DeclaracionJuradaBeneficioZonaFranca.vue?vue&type=script&lang=js&"
export * from "./DeclaracionJuradaBeneficioZonaFranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports